import { mapGetters, mapActions } from 'vuex'
import journal from '../../api/journal'
import publisher from '../../api/publisher'
import file from '../../api/file'

export default {
  data() {
    return {
      journalList: []
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      publisherInfo: 'getPublisherInfo',
      publisherId: 'getPublisherId',
      domain: 'getDomain'
    })
  },
  async mounted() {
    let publisherId = 'imr'
    // if (!location.hostname.includes('192.168')) {
    //   publisherId = location.hostname.split('.')[0]
    // }
    this.getDomain()
    await this.getPublisherInfo(publisherId)
    await this.getJournal()
  },
  methods: {
    ...mapActions([
      'updateLanguage',
      'updatePublisherId',
      'updatePublisherInfo',
      'updateDomain'
    ]),
    async getJournal() {
      this.journalList = await journal.webGet({
        publisherId: this.publisherInfo.id,
        submited: true
      })
    },
    async getPublisherInfo(publisherId) {
      this.updatePublisherInfo(await publisher.query(publisherId))
      this.updatePublisherId(this.publisherInfo.id)
    },
    async getDomain() {
      const domain = await file.domain()
      this.updateDomain(domain)
    }
  }
}
